import { defineFilterSpec, enumField, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { OrderFilterFormValues, OrderListFilters } from './types';

/** Single declaration of the order list filters, shared by api/drawer/page. Multi-selects join
 *  to comma strings on the wire; date bounds pass through as enum (string) fields. */
const spec = defineFilterSpec<OrderListFilters, OrderFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  multiField('cities'),
  multiField('statuses'),
  enumField('orderedFrom'),
  enumField('orderedTo'),
  rangeField('amount'),
  rangeField('deviceCount'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
